"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const CookiesContext_1 = __importDefault(require("../context/CookiesContext"));
const useCookies = () => {
    return (0, react_1.useContext)(CookiesContext_1.default).cookies;
};
exports.default = useCookies;
//# sourceMappingURL=useCookies.js.map